import React from 'react'
import { slugs } from '@/constants/slugs'
import { TranslateFunction, Translate } from '@/utils/translate/translate-client'
import { GiveawayRulesConfig } from './types'

const RULES_CONFIGS: Record<string, GiveawayRulesConfig> = {
  [slugs.theLastRodeo]: {
    content: (t: TranslateFunction) => (
      <Translate t={t} i18nKey={`lastrodeoSweepstakesGeneralRulesFooter_${slugs.theLastRodeo}`}>
        * * * LIMIT OF 3,000 ENTRIES PER PERSON/EMAIL ADDRESS. * * * NO PURCHASE OR PAYMENT OF ANY KIND IS NECESSARY TO
        ENTER OR WIN. PURCHASE OR PAYMENT DOES NOT IMPROVE YOUR CHANCE OF WINNING. The Last Rodeo Giveaway is open only
        to legal residents of the 48 contiguous US States & D.C. (excluding HI and AK), age of majority or older. Void
        elsewhere and where prohibited. Ends 6/7/2025. Subject to complete Official Rules at{' '}
        <a target="_blank" className="underline" href="https://bit.ly/TheLastRodeo">
          https://bit.ly/TheLastRodeo
        </a>
        .
      </Translate>
    ),
  },

  [slugs.kingOfKings]: {
    content: (t: TranslateFunction) => (
      <Translate t={t} i18nKey={`tkokSweepstakesGeneralRulesFooter_${slugs.kingOfKings}`}>
        * * * LIMIT OF 3,000 ENTRIES PER PERSON/EMAIL ADDRESS. * * * NO PURCHASE OR PAYMENT OF ANY KIND IS NECESSARY TO
        ENTER OR WIN. PURCHASE OR PAYMENT DOES NOT IMPROVE YOUR CHANCE OF WINNING. The King of Kings Giveaway is open
        only to legal residents of the 50 US States &amp; D.C., age of majority or older. Void elsewhere and where
        prohibited. Ends 4/27/2025. Odds of winning a prize depend on the number of eligible entries received. Subject
        to complete Official Rules at{' '}
        <a target="_blank" className="underline" href="https://bit.ly/AngelFilmsKingofKings">
          https://bit.ly/AngelFilmsKingofKings
        </a>
        .
      </Translate>
    ),
  },

  [slugs.sketch]: {
    content: (t: TranslateFunction) => (
      <Translate t={t} i18nKey={`sketchSweepstakesGeneralRulesFooter_${slugs.sketch}`}>
        <span>
          <strong>LIMIT OF 3,000 ENTRIES PER PERSON/EMAIL ADDRESS.</strong> * * * NO PURCHASE OR PAYMENT OF ANY KIND IS
          NECESSARY TO ENTER OR WIN. PURCHASE OR PAYMENT DOES NOT IMPROVE YOUR CHANCE OF WINNING. The SKETCH x Freddie
          Wong Ultimate Creator Kit Sweepstakes is open only to legal residents of the 50 US States & DC, age of
          majority +. Void elsewhere and where prohibited. Void elsewhere and where prohibited.{' '}
          <strong>Trip must be taken February 19 – 22, 2026</strong>, Ends 8/18/2025. Subject to complete Official Rules
          at{' '}
          <a href="https://bit.ly/SKETCHxFreddieWong" target="_blank" className="underline">
            https://bit.ly/SKETCHxFreddieWong
          </a>
        </span>
      </Translate>
    ),
  },

  [slugs.youngWashington]: {
    content: (t: TranslateFunction) => (
      <Translate t={t} i18nKey={`sketchSweepstakesGeneralRulesFooter_${slugs.sketch}`}>
        <span>
          * * * <strong>LIMIT OF 1,000 ENTRIES PER PERSON/EMAIL ADDRESS.</strong> * * * NO PURCHASE OR PAYMENT OF ANY
          KIND IS NECESSARY TO ENTER OR WIN. PURCHASE OR PAYMENT DOES NOT IMPROVE YOUR CHANCE OF WINNING. Young
          Washington Giveaway #1 is open only to legal residents of the 50 US States & DC, age of majority +. Void
          elsewhere and where prohibited. Ends 08/5/25. Subject to complete Official Rules at at{' '}
          <a href=" https://bit.ly/YoungWashington" target="_blank" className="underline">
            https://bit.ly/YoungWashington
          </a>
        </span>
      </Translate>
    ),
  },

  [slugs.senior]: {
    content: (t: TranslateFunction) => (
      <Translate t={t} i18nKey={`seniorSweepstakesGeneralRulesFooter_${slugs.senior}`}>
        <p>
          NO PURCHASE NECESSARY. Open only to legal residents of the 50 United States (excluding NY and FL) and the
          District of Columbia, who are of the legal age of majority in their state, are located in the Territory at the
          time of entry, and who meet all eligibility requirements. Void outside the Territory and where prohibited by
          law. Limit 1,000 total entries per person/email address (including ticket purchases, Guild bonuses, and
          mail-in entries) during the Promotion Period. Promotion begins 12:00 a.m. PT on July 31, 2025 and ends 11:59
          p.m. PT on October 17, 2025. Odds of winning depend on number of eligible entries received.
        </p>
        <p>
          For full rules, eligibility, prize details, and mail-in entry information,{' '}
          <a
            className="font-semibold underline"
            href={'https://certified.promotrust.com/AngelFilms/TheSeniorMovieSweepstakes/rules.pdf'}
          >
            see here
          </a>
          .
        </p>
        <p>Sponsor: Angel, Provo, UT. Administered by SweepstakesPros.</p>
      </Translate>
    ),
  },
  [slugs.truthAndTreason]: {
    content: (t: TranslateFunction) => (
      <Translate t={t} i18nKey={`seniorSweepstakesGeneralRulesFooter2_${slugs.senior}`}>
        <p>
          * * * LIMIT OF 500 ENTRIES PER PERSON/EMAIL ADDRESS. * * * NO PURCHASE OR PAYMENT OF ANY KIND IS NECESSARY TO
          ENTER OR WIN. PURCHASE OR PAYMENT DOES NOT IMPROVE YOUR CHANCE OF WINNING. The Truth and Treason Film Giveaway
          is open only to legal residents of the 50 US States & DC, age of majority +. Void elsewhere and where
          prohibited. Ends 10/31/2025. Subject to complete Official Rules at{' '}
          <a className="font-semibold underline" href={'http://bit.ly/TruthandTreasonFilmGiveaway'}>
            bit.ly/TruthandTreasonFilmGiveaway.
          </a>
        </p>
        <p className={'pt-6'}>
          <strong>Sponsor:</strong> Angel, Provo, UT.
        </p>
        <p>
          <strong>Promotion Administrator:</strong> Administered by SweepstakesPros.
        </p>
      </Translate>
    ),
  },
  [slugs.david]: {
    content: (t: TranslateFunction) => (
      <Translate t={t} i18nKey={`davidSweepstakesGeneralRulesFooter2`}>
        <p>
          * * * LIMIT OF 500 ENTRIES PER PERSON/EMAIL ADDRESS. * * * NO PURCHASE OR PAYMENT OF ANY KIND IS NECESSARY TO
          ENTER OR WIN. PURCHASE OR PAYMENT DOES NOT IMPROVE YOUR CHANCE OF WINNING. The David Film Giveaway is open
          only to legal residents of the 50 US States & DC, age of majority +. Void elsewhere and where prohibited. Ends
          01/01/2026. Subject to complete Official Rules at{' '}
          <a
            className="font-semibold underline"
            href={'https://certified.promotrust.com/AngelFilms/DavidSweepstakes/rules.pdf'}
          >
            https://certified.promotrust.com/AngelFilms/DavidSweepstakes/rules.pdf
          </a>
        </p>
        <p className={'pt-6'}>
          <strong>Sponsor:</strong> Angel, Provo, UT.
        </p>
        <p>
          <strong>Promotion Administrator:</strong> Administered by SweepstakesPros.
        </p>
      </Translate>
    ),
  },
  [slugs.iWasAStranger]: {
    content: (t: TranslateFunction) => (
      <Translate t={t} i18nKey={`iwasSweepstakesGeneralRulesFooter2`}>
        <p>
          * * * LIMIT OF 500 ENTRIES PER PERSON/EMAIL ADDRESS. * * * NO PURCHASE OR PAYMENT OF ANY KIND IS NECESSARY TO
          ENTER OR WIN. PURCHASE OR PAYMENT DOES NOT IMPROVE YOUR CHANCE OF WINNING. The I Was a Stranger Film Giveaway
          is open only to legal residents of the 50 US States & DC, age of majority +. Void elsewhere and where
          prohibited. Ends 01/15/2026. Subject to complete Official Rules at{' '}
          <a
            className="font-semibold underline"
            href={'https://certified.promotrust.com/AngelFilms/IWasAStrangerGiveaway/rules.pdf'}
          >
            https://certified.promotrust.com/AngelFilms/IWasAStrangerGiveaway/rules.pdf
          </a>
        </p>
        <p className={'pt-6'}>
          <strong>Sponsor:</strong> Angel, Provo, UT.
        </p>
        <p>
          <strong>Promotion Administrator:</strong> Administered by SweepstakesPros.
        </p>
      </Translate>
    ),
  },
}

export const getRulesConfig = (theatricalSlug: string): GiveawayRulesConfig | null => {
  return RULES_CONFIGS[theatricalSlug] || null
}

export const hasRules = (theatricalSlug: string): boolean => {
  return theatricalSlug in RULES_CONFIGS
}
